// Central product availability status config for the E.O.N shop.
export const PRODUCT_STATUS = {
  in_stock: { label: "In Stock", cta: "Add", buyable: true, tone: "gold", showBadge: false },
  preorder: { label: "Pre-Order", cta: "Pre-Order", buyable: true, tone: "gold", showBadge: true },
  coming_soon: { label: "Coming Soon", cta: null, buyable: false, tone: "gold", showBadge: true },
  sold_out: { label: "Sold Out", cta: null, buyable: false, tone: "muted", showBadge: true },
  reserved: { label: "Reserved", cta: null, buyable: false, tone: "muted", showBadge: true },
};

export function getProductStatus(product) {
  const key = product?.stock_status || (product?.coming_soon ? "coming_soon" : "in_stock");
  return { key, ...(PRODUCT_STATUS[key] || PRODUCT_STATUS.in_stock) };
}

// Tailwind classes for the badge overlay on the product image.
export const BADGE_TONE = {
  gold: "bg-eon-gold text-white",
  muted: "bg-black/70 text-eon-text border border-eon-border",
};
